import { io, Socket } from 'socket.io-client';
import { API_BASE } from './api';

let socket: Socket | null = null;

export function getSocket(token: string): Socket {
  if (socket && socket.connected) return socket;
  // Пустой API_BASE = подключаемся к тому же origin, откуда открыт фронт
  // (Vite proxy в dev, либо один и тот же домен в проде за Nginx).
  socket = io(API_BASE || undefined, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 800,
    reconnectionAttempts: 20,
  });
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}
